import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { LmsService } from "../../_Lms/services/lms.service";
import { QuickLoanService } from "../../_QuickLoan/services/quickLoan.service";

@Component({
  selector: 'app-quickloan-recommendation-creditapproval-view',
  templateUrl: './app-quickloan-recommendation-creditapproval-view.component.html',
  styleUrls: ['./app-quickloan-recommendation-creditapproval-view.component.scss'],
  standalone: false
})
export class AppQuickloanRecommendationCreditapprovalViewComponent implements OnInit {

  @Input() Revert_IsEdit: any;
  @Input() loanSummary: any;
  @Input() Processid: any;
  @Input() PageData: any;
  @Input() Status: any;
  @Input() ProcessName: any;
  @Output() action: EventEmitter<any> = new EventEmitter<any>();

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  pageName: string = "Recommendation Credit Approval";
  currentUser: any;
  masterId: number = 0;

  PositiveRemarks: any[] = [];
  NegativeRemarks: any[] = [];
  RecommendationType: any = "";
  FinalRemark: any = "";

  modalType: string = "";
  newRemark: string = "";
  isEditing: boolean = false;
  editingIndex: number = -1;
  isModalVisible: boolean = false;

  RecommendationTypes: any[] = [
    { id: "Approved", value: "Approved" },
    { id: "Rejected", value: "Rejected" },
    { id: "Conditional Approved", value: "Conditional Approved" },
  ];

  constructor(
    private snackBar: MatSnackBar,
    private _LmsService: LmsService,
    private _QuickLoanService: QuickLoanService
  ) { }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.getRecommendationDetails();
  }

  getRecommendationDetails() {
    this._LmsService
      .Get_RecommendTab_Details({
        LoanId: this.loanSummary?.LoanId,
        PageName: this.pageName
      })
      .subscribe((res: any) => {
        const masterData = res.Item1?.[0];
        const detailData = res.Item2 || [];

        if (masterData) {
          this.masterId = masterData.MasterId;
          this.RecommendationType = masterData.Status || "";
          this.FinalRemark = masterData.FinalRemark || "";
        }

        this.PositiveRemarks = detailData.filter((d: any) => d.Type === "Positive").map((d: any) => ({
          detailId: d.DetailId,
          remark: d.Value
        }));

        this.NegativeRemarks = detailData.filter((d: any) => d.Type === "Negative").map((d: any) => ({
          detailId: d.DetailId,
          remark: d.Value
        }));
      }, () => {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Something went wrong while fetching data",
          ...this.configSuccess,
        });
      });
  }

  openAddModal(type: string) {
    this.modalType = type;
    this.newRemark = "";
    this.isEditing = false;
    this.editingIndex = -1;
    this.isModalVisible = true;
  }

  editRemark(index: number, type: string) {
    const list = type === "positive" ? this.PositiveRemarks : this.NegativeRemarks;
    this.modalType = type;
    this.editingIndex = index;
    this.newRemark = list[index]?.remark || "";
    this.isEditing = true;
    this.isModalVisible = true;
  }

  closeModal() {
    this.isModalVisible = false;
    this.newRemark = "";
    this.isEditing = false;
    this.editingIndex = -1;
  }

  saveRemark() {
    if (!this.newRemark?.trim()) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Please enter a remark",
        ...this.configSuccess,
      });
      return;
    }

    const recommendType = this.modalType === "positive" ? "Positive" : "Negative";
    const list = this.modalType === "positive" ? this.PositiveRemarks : this.NegativeRemarks;
    const existingItem = this.isEditing && this.editingIndex >= 0 ? list[this.editingIndex] : null;

    this._LmsService
      .Save_RecommendTab_Details({
        Loan_Id: this.loanSummary?.LoanId,
        PageName: this.pageName,
        RecommendType: recommendType,
        RecommendRemark: this.newRemark.trim(),
        Int_Id: existingItem?.detailId || 0,
        Action: "SAVE",
        LoginUserId: this.currentUser?.userId
      })
      .subscribe((res: any) => {
        this.snackBar.openFromComponent(SnackbarComponent, { data: res[0]?.MSG || "Remark saved successfully", ...this.configSuccess });
        this.getRecommendationDetails();
        this.closeModal();
      });
  }

  deleteRemark(index: number, type: string) {
    const list = type === "positive" ? this.PositiveRemarks : this.NegativeRemarks;
    const item = list[index];
    if (!item?.detailId) return;

    this._LmsService
      .Save_RecommendTab_Details({
        Loan_Id: this.loanSummary?.LoanId,
        PageName: this.pageName,
        Int_Id: item.detailId,
        Action: "DELETE",
        LoginUserId: this.currentUser?.userId
      })
      .subscribe((res: any) => {
        this.snackBar.openFromComponent(SnackbarComponent, { data: res[0]?.MSG || "Remark deleted successfully", ...this.configSuccess });
        this.getRecommendationDetails();
      });
  }

  QuickLoan_Save_PageProcess() {
    this._QuickLoanService
      .QuickLoan_Save_PageProcess({
        PageType: this.pageName,
        ProductId: this.loanSummary?.ProductId,
        Loan_Id: this.loanSummary?.LoanId,
        Process_Id: this.Processid,
        Page_Id: this.PageData?.MM_Id,
        LoginUserId: this.currentUser?.userId,
      })
      .subscribe();
  }

  saveData() {
    this._LmsService
      .Save_RecommendTab_FinalStatus({
        LoanId: this.loanSummary?.LoanId,
        PageName: this.pageName,
        Status: this.RecommendationType,
        FinalRemark: this.FinalRemark.trim(),
        LoginUserId: this.currentUser?.userId
      })
      .subscribe((res: any) => {
        this.snackBar.openFromComponent(SnackbarComponent, { data: res[0]?.MSG || "Saved successfully", ...this.configSuccess });
        this.QuickLoan_Save_PageProcess();
        this.action.emit("next");
      });
  }

  get canSave(): boolean {
    return !!this.RecommendationType && !!this.FinalRemark?.trim();
  }

  get hasRemarks(): boolean {
    return this.PositiveRemarks.length > 0 || this.NegativeRemarks.length > 0;
  }

}
